// extracted by mini-css-extract-plugin
export var leftAlign = "_m-2";
export var popper = "_m-0";
export var subtitle = "_m-1";